<script>
  import { createEventDispatcher } from "svelte";
  import { formatDur, spanColor } from "./utils.js";

  export let selectedSpan = null;
  export let detailHeight = 200;
  export let isResizing = false;
  export let colorBy = "name";

  const dispatch = createEventDispatcher();
</script>

{#if selectedSpan}
  <div class="shrink-0 bg-surface flex flex-col" style="height:{detailHeight}px;">
    <!-- Resize handle -->
    <!-- svelte-ignore a11y-no-static-element-interactions -->
    <div
      class="shrink-0 h-1.5 border-t-2 border-line-strong hover:border-blue-400 {isResizing
        ? 'border-blue-400'
        : ''} cursor-row-resize transition-colors"
      on:mousedown={(e) => dispatch("startResize", e)}
    ></div>
    <div class="flex items-center justify-between px-4 py-2 border-b bg-surface-sunken shrink-0">
      <div class="flex items-center gap-2 min-w-0">
        <span
          class="inline-block w-2.5 h-2.5 rounded-sm shrink-0"
          style="background-color:{spanColor(selectedSpan, colorBy).bg};"
        ></span>
        <span class="text-sm font-semibold text-content truncate">{selectedSpan.name}</span>
      </div>
      <div class="flex items-center gap-3 text-xs text-content-subtle shrink-0 ml-3">
        <span class="font-medium text-content">
          {formatDur(selectedSpan.end_time_ns - selectedSpan.start_time_ns)}
        </span>
        {#if selectedSpan.kind}
          <span class="text-gray-300">|</span>
          <span>{selectedSpan.kind}</span>
        {/if}
        <span class="text-gray-300">|</span>
        <button
          class="text-blue-600 hover:text-blue-800 font-medium"
          on:click={() => dispatch("openTrace", { span: selectedSpan })}
        >
          View trace →
        </button>
        <button
          class="text-content-subtle hover:text-content text-base leading-none ml-1"
          on:click={() => dispatch("close")}
        >
          ✕
        </button>
      </div>
    </div>
    <div class="flex-1 min-h-0 overflow-y-auto px-4 py-2">
      <div class="grid grid-cols-[auto_1fr] gap-x-4 gap-y-0.5 text-xs">
        <span class="text-content-subtle whitespace-nowrap">trace_id</span>
        <span class="font-mono text-content-muted truncate">{selectedSpan.trace_id}</span>
        <span class="text-content-subtle whitespace-nowrap">span_id</span>
        <span class="font-mono text-content-muted">{selectedSpan.span_id}</span>
        {#if selectedSpan.parent_span_id}
          <span class="text-content-subtle whitespace-nowrap">parent_span_id</span>
          <span class="font-mono text-content-muted">{selectedSpan.parent_span_id}</span>
        {/if}
        {#each Object.entries(selectedSpan.attributes || {}) as [k, v]}
          <span class="text-content-subtle whitespace-nowrap">{k}</span>
          <span class="font-mono text-content-muted break-all">{v}</span>
        {/each}
      </div>
    </div>
  </div>
{/if}
